import { render } from "./Cautionary.vue?vue&type=template&id=d4cdb43e"
import script from "./Cautionary.vue?vue&type=script&lang=js"
export * from "./Cautionary.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\Mbf5_HCC\\XaQuangHa\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__